module.exports = __webpack_public_path__ + "03_long_black.3b1a1aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_long_black.png
// module id = fM1S
// module chunks = 0